// Client-side check of a JWT's `exp` claim, so the app can tell "there's a
// token in localStorage" apart from "there's a token that will actually be
// accepted by the backend." This doesn't verify the signature (the backend
// already does that on every request) — it just avoids optimistically
// rendering protected pages with a token that's guaranteed to 401.
export default function isTokenExpired(token) {
  if (!token) return true;

  const parts = token.split('.');
  if (parts.length !== 3) return true;

  try {
    let base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    base64 += '='.repeat((4 - (base64.length % 4)) % 4);
    const payload = JSON.parse(atob(base64));
    if (typeof payload.exp !== 'number') return true;
    return Date.now() >= payload.exp * 1000;
  } catch {
    return true;
  }
}
